<template>
    <div>
        <PullContainer
            ref="pullContainerRef"
            :pullDownLoading="true"
            :pullDownLabel="true"
            @pullDownLoadingSuccess="pullDownLoadingSuccess"
        >
            <template #container>
                <div class="public_container">
                    <div class="returnNavBar">
                        <ReturnNavBar title="返回" :isTitleNormal="true" :isAllFunctions="true"> </ReturnNavBar>
                    </div>
                    <div class="mobile_container" v-loading="loading">
                        <ul v-infinite-scroll="onLoadList">
                            <li v-for="(row,rowIndex) in tableData" :key="rowIndex" class="list_item" @click="handleClickToDetail(row)">
                                <span class="ellipsis">{{ row.name }}</span>
                                <span>近30日跟进{{row.followups}}次</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </template>
        </PullContainer>
    </div>
</template>

<script>
import { TopFollowups } from "@/api";
import { pagination } from "@/mixins";
import PullContainer from "@/components/mComponents/PullContainer.vue";
import ReturnNavBar from "@/components/mComponents/ReturnNavBar.vue";
export default {
    name: "MajorCustomer",
    components: {
        PullContainer,
        ReturnNavBar,
    },
    data() {
        return {
            loading: false,
            tableData: [],
        };
    },
    mixins: [pagination],
    created() {
        this.getTableData();
    },
    methods: {
        pullDownLoadingSuccess(flag) {
            if (flag) {
                this.pullDownLoading = true;
                this.handleClickSearch();
            }
        },
        handleClickSearch() {
            this.pagination.pageNum = 1;
            this.tableData = [];
            this.getTableData();
        },
        // 加载更多
        onLoadList() {
            if (this.pagination.total == this.tableData.length) {
                return false;
            }
            if (this.loading == false) {
                this.getTableData();
            }
        },
        getTableData() {
            this.loading = true;
            let postData = {
                page: this.pagination.pageNum,
                pageSize: this.pagination.pageSize,
            };
            TopFollowups(postData).then((res) => {
                if (res.code === 200) {
                    let { list, total } = res.data;
                    this.tableData = this.tableData.concat(list);
                    this.pagination.total = total;
                    this.pagination.pageNum++;
                    this.loading = false;
                    if (this.pullDownLoading) {
                        this.pullDownLoading = false;
                        this.$refs.pullContainerRef.pullDownLoadingEnd("刷新成功");
                    }
                }
            });
        },
        // 查看详情
        handleClickToDetail(row) {
            this.$router.push({
                name: "CustomerPrivateSeasDetail",
                params: {
                    isPush: true,
                },
                query: {
                    customer_id: row.customer_id,
                    name: row.name,
                },
            });
        }
    },
};
</script>

<style lang="scss" scoped>
.mobile_container {
    padding: 10px 16px;
    ul {
        li {
            border-radius: 6px;
            background: rgba(255, 255, 255, 1);
            padding: 22px 10px;
            display: flex;
            gap: 18px;
            margin-bottom: 10px;
            span:nth-child(1) {
                flex: 1;
                font-size: 16px;
                font-weight: 400;
                letter-spacing: 0px;
                line-height: 24px;
                color: rgba(41, 144, 240, 1);
            }
            span:nth-child(2) {
                font-size: 10px;
                font-weight: 400;
                letter-spacing: 0px;
                line-height: 24px;
                color: rgba(153, 153, 153, 1);
            }
            &:active {
                background-color: rgba(153, 153, 153, 0.04);
            }
        }
    }
}
</style>
